import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject, combineLatest } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import {
  CommissioningStore,
  GatewayStore,
  InstallationDetailsStore,
  InstallationFeaturesStore,
} from '@store';
import { CommissioningService } from '../commissioning/commissioning.service';

@Component({
  selector: 'app-src-commissioning-overlay',
  templateUrl: './src-commissioning-overlay.component.html',
  styleUrls: ['./src-commissioning-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcCommissioningOverlayComponent implements OnInit, OnDestroy {
  areResults$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  installationId: number;

  @Input() gatewaySerial: string;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public gatewayStore: GatewayStore,
    public activatedRoute: ActivatedRoute,
    public installationDetailsStore: InstallationDetailsStore,
    private commissioningStore: CommissioningStore,
    private commissioningService: CommissioningService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.gatewaySerial = this.activatedRoute.snapshot.queryParams['gatewaySerial'];
    this.initActivatedRouteSubscription();
    this.initItemsSubscription();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onAddRoom(): void {
    this.commissioningService.openAddRoomDialog();
  }

  onAddDevice(): void {
    this.commissioningService.openAddDeviceDialog();
  }

  private initActivatedRouteSubscription(): void {
    this.commissioningStore.listFeatures();
  }

  private initItemsSubscription(): void {
    combineLatest([this.installationFeaturesStore.rooms$, this.gatewayStore.devicesFlag$])
      .pipe(
        map((data) => data && (!!data[0].length || !data[1].empty)),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((areResults) => {
        this.areResults$.next(areResults);
      });
  }
}
